<template>
    <router-link v-if="givData" :to="`/givs/${givData.id}`">
        <div
            class="px-4 md:px-6 py-4 md:py-2 border border-gray-100 rounded shadow-sm hover:shadow transition duration-150"
        >
            <div class="md:flex items-center justify-between">
                <div class="md:w-36 flex justify-between">
                    <span
                        class="text-xs font-medium text-teal-700 px-3 rounded-full"
                        :class="[
                            givData.type === 'meetup'
                                ? 'bg-green-50 md:bg-green-100'
                                : 'bg-blue-50 md:bg-blue-100',
                        ]"
                        >{{ givData.type }}</span
                    >
                </div>
                <div
                    v-if="givData && givData.giver && givData.receiver"
                    class="py-3 md:py-0 md:ml-8 flex-1 flex items-center"
                >
                    <span v-show="!hideGiver" class="flex-1 md:text-right"
                        >{{ givData.giver.name }} </span
                    ><svg
                        class="flex-1 w-6 h-6 text-gray-300"
                        fill="none"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="2"
                        viewBox="0 0 24 24"
                        stroke="currentColor"
                    >
                        <path d="M14 5l7 7m0 0l-7 7m7-7H3"></path>
                    </svg>
                    <span v-show="!hideReceiver" class="flex-1 text-right md:text-left"
                        >{{ givData.receiver.name }}
                    </span>
                </div>
                <div class="flex justify-between items-center md:space-x-3">
                    <span class="text-xs">{{ formatDate(givData.createdAt) }}</span>
                    <div class="flex items-center">
                        <svg
                            class="w-4 h-4 md:w-5 md:h-5 mr-1"
                            fill="none"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            stroke-width="2"
                            viewBox="0 0 24 24"
                            stroke="currentColor"
                        >
                            <path
                                v-if="givData.status === 'finished'"
                                class="text-green-500"
                                d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
                            ></path>
                            <path
                                v-else
                                class="text-red-400"
                                d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                            ></path>
                        </svg>
                        <span class="text-xs uppercase tracking-wide md:font-medium">{{
                            givData.status
                        }}</span>
                    </div>
                </div>
            </div>
        </div>
    </router-link>
</template>

<script>
import { formatDistanceToNow } from 'date-fns'
import api from '../lib/api'
export default {
    props: ['giv', 'givId', 'hideGiver', 'hideReceiver'],
    data() {
        if (!this.giv && !!this.givId) {
            api.getGiv(this.givId).then(d => {
                this.givData = d
            })
        }

        return {
            givData: this.giv || null,
        }
    },
    methods: {
        formatDate(dateStr) {
            //@Todo we don't have Date scalar yet in our graphql schema so need to parseInt the string
            try {
                return `Created ${formatDistanceToNow(new Date(dateStr), {
                    addSuffix: true,
                })}`
            } catch (err) {
                console.error(err.message)
                return null
            }
        },
    },
}
</script>
